export enum IssueStage {

    Reported="Reported",
    Resolving= "Resolving",
    Resolved="Resolved",
    Developed="Developed",
    Developing="Developing",
    Received_Feedback="Received_Feedback",
    Received_Question="Received_Question",
    Answered_Question="Answered_Question",
    Decline="Decline",
}
